import { render } from "./customerRegister.vue?vue&type=template&id=3fe6dfdb&scoped=true"
import script from "./customerRegister.vue?vue&type=script&lang=js"
export * from "./customerRegister.vue?vue&type=script&lang=js"

import "./customerRegister.vue?vue&type=style&index=0&id=3fe6dfdb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe6dfdb"]])

export default __exports__